export default "__VITE_PUBLIC_ASSET__2cfdf51b__"